<template>
    <v-row justify="end" align="center" class="row--small">
        <template v-if="!accessToken">
            <v-col cols="auto">
                <v-btn text color="grey-13"><span class="font-size-lg-18 font-weight-bold" @click="$refs['dialog-join'].shows = true">회원가입</span></v-btn>
            </v-col>
             <v-col cols="auto">
                <v-divider vertical class="grey-d" style="min-height: 16px;"/>
             </v-col>
            <v-col cols="auto">
                <v-btn text color="primary" @click="$refs['dialog-login'].shows = true"><span class="font-size-lg-18 font-weight-bold">로그인</span></v-btn>                
            </v-col>
        </template>
        <template v-else>
            <v-col cols="auto">
                <v-btn text color="grey-13" @click="logout"><span class="font-size-lg-18 font-weight-bold">로그아웃</span></v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn text color="primary" href="/dashboard"><span class="font-size-lg-18 font-weight-bold">대시보드</span></v-btn>
            </v-col>
        </template>
        <dialog-login ref="dialog-login" />
        <dialog-join ref="dialog-join" />
    </v-row>
</template>

<script>
import { mapActions } from "vuex";
import DialogLogin from "@/components/client/login/dialog-login.vue";
import DialogJoin from "../join/dialog-join/dialog-join.vue";

export default {
    components: {
        DialogLogin,
        DialogJoin,
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
    methods: {
        ...mapActions(["logout"]),
    },
};
</script>
<style lang="scss" scoped>
</style>